export default __webpack_public_path__ + "static/media/animal_print.fda89457.jpeg";